<template>
    <div class="content-block">
        <b-form name="printSettingsForm" v-on:submit.prevent="$_onSaveForm">
            <div
                v-for="formElement in componentList"
                :key="`x${formElement.id}`"
            >
                <print-settings-form-configuration-component
                    :component-configuration="formElement"
                    @change="
                        $_onChangeCustomComponentSettings(formElement, $event)
                    "
                    @changeCheckbox="$_onChangeCheckbox(formElement, $event)"
                    @updateOptions="$_onUpdateOptions(formElement, $event)"
                />
            </div>
            <div class="sticky-bottom fixed-bottom">
                <submit-cancel-remove
                    :id="`printSettings`"
                    :is-saving="isSaving"
                    :mode="modeAddConst"
                    @cancel="$_onCancel"
                >
                </submit-cancel-remove>
            </div>
        </b-form>
    </div>
</template>

<script>
    import { MODE_ADD } from '../../../constants';

    import PrintSettingsFormConfigurationComponent from './PrintSettingsFormConfigurationComponent.vue';
    import SubmitCancelRemove from '../../../components/SubmitCancelRemove.vue';

    export default {
        components: {
            'print-settings-form-configuration-component':
                PrintSettingsFormConfigurationComponent,
            'submit-cancel-remove': SubmitCancelRemove
        },
        props: {
            defaultForm: { type: Array, required: true },
            printConfiguration: { type: Object, required: true }
        },

        data() {
            return {
                // Constants
                modeAddConst: MODE_ADD,

                isSaving: false,
                userDefaultForm: null
            };
        },

        methods: {
            init() {
                this.userDefaultForm = JSON.parse(JSON.stringify(this.defaultForm));
            },
            $_onCancel() {
                this.$router.push({ path: '/' });
            },
            $_onSaveForm() {
                this.$emit('save', this.userDefaultForm);
            },
            $_onChangeCheckbox(component, active) {
                if (active) {
                    this.userDefaultForm.push(component.custom);
                } else {
                    this.userDefaultForm = this.userDefaultForm.filter(
                        ({ id }) => id !== component.id
                    );
                }
            },
            $_onChangeCustomComponentSettings(formElement, customSettings) {
                const itemIndex = this.userDefaultForm.findIndex(
                    ({ id }) => id === formElement.id
                );
                const userDefaultForm = [...this.userDefaultForm];
                userDefaultForm[itemIndex] = customSettings;
                this.userDefaultForm = userDefaultForm;
            },
            $_onUpdateOptions(formElement, options) {
                const itemIndex = this.userDefaultForm.findIndex(
                    ({ id }) => id === formElement.id
                );
                const userDefaultForm = [...this.userDefaultForm];
                userDefaultForm[itemIndex].options = options;
                this.userDefaultForm = userDefaultForm;
            }
        },
        watch: {
            defaultForm: {
                handler: 'init',
                immediate: true
            }
        },
        computed: {
            componentList: function () {
                const arrayTextSort = function (a, b) {
                    if (a.text < b.text) {
                        return -1;
                    }
                    if (a.text > b.text) {
                        return 1;
                    }
                    return 0;
                };

                const sortedArray = [
                    ...this.printConfiguration.default.default.form
                ]
                    .map((defaultcomponent) => {
                        const customComponentSetting = this.userDefaultForm.find(
                            (component) => component.id === defaultcomponent.id
                        );
                        const textStripped = defaultcomponent.id
                            .replace('show', '')
                            .toLowerCase();
                        const text = this.$t(
                            `printComponent.${textStripped}`
                        ).toLowerCase();
                        return {
                            default: defaultcomponent,
                            custom: customComponentSetting || defaultcomponent,
                            id: defaultcomponent.id,
                            text: `${this.$t(
                                'printComponent.dashboard.options'
                            )} ${text}`
                        };
                    })
                    .sort(arrayTextSort);

                // Move 'previewzoom' to beginning of array
                sortedArray.unshift(
                    sortedArray.splice(
                        sortedArray.findIndex((item) => item.id === 'previewzoom'),
                        1
                    )[0]
                );
                return sortedArray;
            },
            dirty: function () {
                return (
                    JSON.stringify(this.defaultForm) !==
                    JSON.stringify(this.userDefaultForm)
                );
            }
        }
    };
</script>

<style scoped>
.content-block {
    margin-bottom: 100px;
}
</style>
